class Megamenu {
  constructor(container) {
    this.selectors = {
      announcementBar: ".m-announcement-bar",
      hamburgerButtons: ".m-hamburger-box",
      desktopMenuItems: [".m-menu__item"],
      desktopSubMenus: ".m-mega-menu",
      headerMobile: ".m-header__mobile",
      menuDrawer: "#m-menu-drawer",
      menuDrawerContent: ".m-menu-drawer__content",
      menu: ".m-menu-mobile",
      menuItems: [".m-menu-mobile__item"],
      megaMenuMobile: [".m-megamenu-mobile"],
      backDrop: ".m-menu-drawer__backdrop"
    };
    this.menuSelectors = { subMenu: ".m-mega-menu" };
    this.activeDesktopMenuItem = null;
    this.sliders = {};
    this.open = !1;
    this.container = container;
    this.transitionDuration = 0;
    // 使用 container 作为查询上下文，如果 container 不存在则使用 document
    const queryContext = this.container || document;
    this.domNodes = queryDomNodes(this.selectors, queryContext);
    this.menuData = [...this.domNodes.desktopMenuItems].map((item) => {
      const header = item.closest("header"),
        menuNodes = queryDomNodes(this.menuSelectors, item);
      return { header, item, ...menuNodes, active: !1 };
    });
    this.init();
    MinimogTheme = MinimogTheme || {};
    MinimogTheme.headerSliders = this.sliders;
  }

  init() {
    // 添加空检查，确保元素存在
    if (!this.domNodes.hamburgerButtons) {
      console.warn('Megamenu: hamburgerButtons element not found');
      return;
    }
    if (!this.domNodes.menuDrawer) {
      console.warn('Megamenu: menuDrawer element not found');
      return;
    }
    
    this.domNodes.hamburgerButtons.addEventListener("click", (e) => {
      this.domNodes.hamburgerButtons.classList.contains("active")
        ? this.closeMenu()
        : this.openMenu();
      this.domNodes.hamburgerButtons.classList.toggle("active");
    });
    
    if (this.domNodes.backDrop) {
      this.domNodes.backDrop.addEventListener("click", (e) => {
        this.closeMenu();
      });
    }
    
    this.initMobileMegaMenu();
    this.initDesktopMegaMenu();
    
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => {
      this.open && this.closeMenu();
    });
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openSearchPopup, () => {
      this.open && this.closeMenu();
    });
  }

  initDesktopMegaMenu() {
    [...this.menuData].forEach((menuItem) => {
      const { item, subMenu } = menuItem;
      if (subMenu) {
        const productsBanner = subMenu.querySelector(".m-mega-product-list");
        productsBanner &&
          (window && window.__sfWindowLoaded
            ? (menuItem.productsBannerSlider = this.initProductsBanner(productsBanner))
            : window.addEventListener("load", () => {
                menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
              }));
      }
    });
  }

  closeDesktopSubmenu = (menuItemIndex) => {
    const menuItem = this.menuData[menuItemIndex],
      { header } = menuItem;
    header && header.classList.remove("show-menu");
  };

  initProductsBanner(banner) {
    const header = banner.closest("header"),
      menuItem = banner.closest(".m-menu__item"),
      screenClass = (header && `.${header.dataset.screen}`) || "",
      id = banner.dataset.id,
      columns = document.querySelector(`.m-product-list-${id}`).dataset.column;
    let slider;
    return (
      header &&
        menuItem &&
        (slider = new MinimogLibs.Swiper(
          banner.closest(".m-mega-menu").querySelector(`.swiper-container${screenClass}`),
          {
            slidesPerView: 2,
            spaceBetween: 16,
            breakpoints: { 768: { slidesPerView: columns } }
          }
        )),
      this.sliders[`${menuItem.dataset.index}-${id}`] = slider,
      slider
    );
  }

  initMobileMegaMenu() {
    this.transitionDuration = 300;
    this.domNodes.menuItems &&
      this.domNodes.menuItems.forEach((menuItem) => {
        const subMenuContainer = menuItem.querySelector(".m-megamenu-mobile");
        if (subMenuContainer) {
          const toggleButtons = menuItem.querySelectorAll("[data-toggle-submenu]");
          toggleButtons &&
            toggleButtons.forEach((toggleButton) => {
              toggleButton.addEventListener("click", (e) => {
                e.preventDefault();
                const level = toggleButton.dataset.toggleSubmenu;
                this.openSubMenu(subMenuContainer, level);
              });
            });
          const backButton = subMenuContainer.querySelector(".m-menu-mobile__back-button");
          backButton &&
            backButton.addEventListener("click", () => {
              const level = backButton.dataset.level;
              this.closeSubMenu(subMenuContainer, level);
            });
        }
      });
    document.addEventListener("matchMobile", () => this.setMenuHeight());
    document.addEventListener("unmatchMobile", () => this.setMenuHeight());
  }

  openMenu() {
    this.setMenuHeight();
    document.documentElement.classList.add("prevent-scroll");
    this.domNodes.menuDrawer.classList.add("open");
    this.domNodes.headerMobile && this.domNodes.headerMobile.classList.add("header-drawer-open");
    this.open = !0;
  }

  closeMenu() {
    const { menuDrawer, menu, megaMenuMobile, hamburgerButtons } = this.domNodes;
    setTimeout(() => {
      megaMenuMobile && megaMenuMobile.forEach((container) => {
        container.classList.remove("open");
      });
      menu && menu.classList.remove("m-submenu-open", "m-submenu-open--level-1", "m-submenu-open--level-2");
      menuDrawer && menuDrawer.classList.remove("open");
      document.documentElement.classList.remove("prevent-scroll");
      this.domNodes.headerMobile && this.domNodes.headerMobile.classList.remove("header-drawer-open");
      hamburgerButtons && hamburgerButtons.classList.remove("active");
    }, this.transitionDuration);
    this.open = !1;
  }

  openSubMenu(subMenuContainer, level) {
    let subMenuOpenClass = `m-submenu-open--level-${level}`;
    this.domNodes.menuDrawerContent && this.domNodes.menuDrawerContent.classList.add("open-submenu");
    this.domNodes.menu && this.domNodes.menu.classList.add("m-submenu-open");
    this.domNodes.menu && this.domNodes.menu.classList.add(subMenuOpenClass);
    subMenuContainer.classList.add("open");
  }

  closeSubMenu(subMenuContainer, level) {
    let subMenuOpenClass = `m-submenu-open--level-${level}`;
    level === "1" && this.domNodes.menu && this.domNodes.menu.classList.remove("m-submenu-open");
    this.domNodes.menu && this.domNodes.menu.classList.remove(subMenuOpenClass);
    subMenuContainer.classList.remove("open");
    this.domNodes.menuDrawerContent && this.domNodes.menuDrawerContent.classList.remove("open-submenu");
  }

  setMenuHeight() {
    const { menuDrawer, headerMobile } = this.domNodes;
    if (!headerMobile || !menuDrawer) return;
    const offsetBottom = headerMobile.getBoundingClientRect().bottom,
      panelHeight = window.innerHeight - offsetBottom;
    menuDrawer.style.setProperty("--menu-drawer-height", `${panelHeight}px`);
  }
}

class SiteNav {
  constructor(container) {
    this.selectors = {
      menuItems: [".m-menu .m-menu__item"],
      dropdowns: [".m-mega-menu"],
      subMenu: ".m-mega-menu",
      overlay: ".m-header__overlay",
      swiper: ".swiper-container"
    };
    this.classes = {
      slideFromRight: "slide-from-right",
      slideReveal: "slide-reveal",
      active: "m-mega-active"
    };
    this.headerSticky = !1;
    container &&
      ((this.container = container),
      (this.domNodes = queryDomNodes(this.selectors, this.container)),
      (this.activeIndex = -1),
      (this.lastActiveIndex = -1),
      (this.visited = !1),
      (this.timeoutEnter = null),
      (this.timeoutLeave = null),
      this.attachEvents());
  }

  attachEvents = () => {
    this.domNodes.menuItems && this.domNodes.menuItems.forEach((menuItem, index) => {
      menuItem.addEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.addEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));
    });
  };

  onMenuItemEnter = (evt, index) => {
    if ((evt.target.matches("[data-mega-menu]"), !this.visited)) {
      this.timeoutEnter = setTimeout(() => {
        this.handleOpen(evt, index);
      }, 100);
    }
  };

  onMenuItemLeave = (evt, index) => {
    clearTimeout(this.timeoutEnter);
    this.timeoutLeave = setTimeout(() => {
      this.handleClose(index);
    }, 100);
  };

  handleOpen = (evt, index) => {
    const { dropdowns } = this.domNodes;
    if (!dropdowns || !dropdowns[index]) return;
    
    const dropdown = dropdowns[index],
      subMenu = dropdown.querySelector(this.selectors.subMenu),
      headerInner = this.container.querySelector(".m-header__inner"),
      headerDropdownBg = this.container.querySelector(".m-header__dropdown-bg");
    
    this.activeIndex = index;
    this.lastActiveIndex = index;
    
    headerInner && headerInner.classList.add(this.classes.slideFromRight);
    dropdown.classList.add(this.classes.active);
    headerDropdownBg && headerDropdownBg.classList.add(this.classes.active);
    
    if (subMenu) {
      subMenu.classList.add(this.classes.slideReveal);
      const columns = subMenu.querySelectorAll(":scope > .m-mega-menu__column");
      columns &&
        columns.forEach((column, i) => {
          column.style.animation = `fade-in-up 0.3s ease ${0.1 * i}s forwards`;
        });
    }
    
    this.container.classList.add(this.classes.active);
  };

  handleClose = (index) => {
    if (this.activeIndex === -1) return;
    
    const { dropdowns } = this.domNodes;
    if (!dropdowns || !dropdowns[index]) return;
    
    const dropdown = dropdowns[index],
      subMenu = dropdown.querySelector(this.selectors.subMenu),
      headerInner = this.container.querySelector(".m-header__inner"),
      headerDropdownBg = this.container.querySelector(".m-header__dropdown-bg");
    
    headerInner && headerInner.classList.remove(this.classes.slideFromRight);
    dropdown.classList.remove(this.classes.active);
    headerDropdownBg && headerDropdownBg.classList.remove(this.classes.active);
    
    if (subMenu) {
      subMenu.classList.remove(this.classes.slideReveal);
      const columns = subMenu.querySelectorAll(":scope > .m-mega-menu__column");
      columns &&
        columns.forEach((column) => {
          column.style.animation = "";
        });
    }
    
    this.container.classList.remove(this.classes.active);
    this.activeIndex = -1;
  };

  initDropdownSize = () => {
    this.container &&
      (this.container.style.setProperty("--sf-dropdown-width", this.windowWidth()),
      this.container.style.setProperty("--sf-dropdown-height", this.windowHeight()));
  };

  windowWidth = () => window.innerWidth;
  windowHeight = () => window.innerHeight;
}
